import { useState } from 'react';
import { CustomerClient } from '../../helpers/client';
import { RootState } from '../../redux/store';
import { CustomerInfo } from 'orderme-api-integration-client';
import { assignCustomerDetails } from '../../helpers/customerHelper';
import { Input, Label } from '../../controls';
import { Button, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/hooks';

export function ActivateCoupon() {
  const [coupon, setCoupon] = useState('');
  const [isBusy, setIsBusy] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const customerInfo: CustomerInfo = useAppSelector((state: RootState) => state.customerState.customerInfo);
  const customerClient = new CustomerClient();
  const { t } = useTranslation();

  const activateCoupon = async () => {
    try {
      setIsSuccess(null);
      setIsBusy(true);
      await customerClient.useCoupon(customerInfo.id, coupon);
      await assignCustomerDetails();
      setIsSuccess(true);
      setCoupon('');
    } catch {
      setIsSuccess(false);
    } finally {
      setIsBusy(false);
    }
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ color: 'black', mb: '10px' }}>
        {t('credits:couponDescription')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { sm: 'flex-start' },
          gap: { xs: 1, sm: 2 },
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Input placeholder={t('credits:couponInput')} onChange={setCoupon} value={coupon} />
          <Box sx={{ mt: '10px', ml: '15px' }}>
            <Label
              sx={{ textAlign: 'left' }}
              isVisible={isSuccess !== null}
              type={isSuccess ? 'success' : 'error'}
              content={isSuccess ? t('credits:creditsAdded') : t('credits:invalidCoupon')}
            />
          </Box>
        </Box>
        <Button sx={{ minWidth: '200px' }} onClick={() => activateCoupon()} disabled={isBusy || !coupon}>
          {t('credits:activateCoupon')}
        </Button>
      </Box>
    </Box>
  );
}
